"use strict";
// _partialFile.js

{
  // 日付入力の値変更を監視
  document.querySelectorAll('input[type="date"]').forEach((input) => {
    function updatePlaceholder() {
      if (input.value) {
        input.classList.add("has-value");
      } else {
        input.classList.remove("has-value");
      }
    }

    input.addEventListener("change", updatePlaceholder);
    input.addEventListener("input", updatePlaceholder);
    updatePlaceholder(); // 初期チェック
  });
}
